import { useCallback, useContext } from 'react';

import { useFeatureFlag, useInitialize } from '@kameleoon/react-sdk';

import { ApplicationContext } from '../contexts/Application';

export const useKameleoonFeature = (featureKey: string) => {
    const { isInitialized } = useInitialize();
    const { getFeatureFlagVariationKey } = useFeatureFlag();

    const { applicationEmail } = useContext(ApplicationContext);

    const getVariationKey = useCallback(
        async (email?: string): Promise<string | null> => {
            return isInitialized()
                ? getFeatureFlagVariationKey(
                      email || applicationEmail,
                      featureKey,
                  )
                : null;
        },
        [
            getFeatureFlagVariationKey,
            applicationEmail,
            featureKey,
            isInitialized,
        ],
    );

    return getVariationKey;
};
